import { SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST } from '../api/bacsActions';
import { SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST } from '../api/chapsActions';
import {
	SUBMIT_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
} from '../api/fasterPaymentActions';
import { getFromAccount, getPayments } from '../bacsCredit/selectors';
import { getChapsPaymentsList } from '../chaps/selectors';
import { SUBMIT_IFT_EDIT_PAYMENT_REQUEST, SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST } from '../ift/actions';
import { getIFTPayments } from '../ift/selectors';
import { CONST_REMITTANCE } from '../../config/constants';
import { formatAmount } from '../../helpers/fieldHelpers';
import { getCurrencyDecimalPlaces } from '../../utils/countryUtils';

export const getPaymentsForBiocatch = (state, actionType) => {
	if (!state) {
		return [];
	}

	switch (actionType) {
		case SUBMIT_CONFIRMED_PAYMENT_REQUEST:
		case SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST: {
			return state.payments;
		}

		case SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST: {
			return getChapsPaymentsList(state);
		}

		case SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST: {
			return getPayments(state).map((payment) => ({ ...payment, fromAccount: getFromAccount(state) }));
		}

		case SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST:
		case SUBMIT_IFT_EDIT_PAYMENT_REQUEST: {
			return getIFTPayments(state).map((payment) => {
				const { rates } = payment;
				// Edge case
				if (!rates) {
					return { ...payment, amount: payment.sendAmount, currencyCode: payment.sendCurrency };
				}

				const { details: rateDetails = [] } = rates;
				const [{ payment_amount: ratePaymentTypes } = {}] = rateDetails;
				const { currency: currencyCode, value: rawRemittanceAmount } =
					ratePaymentTypes?.find(({ type }) => type === CONST_REMITTANCE) ?? {};

				const remittanceAmount =
					rawRemittanceAmount && formatAmount(rawRemittanceAmount, getCurrencyDecimalPlaces(currencyCode));

				return { ...payment, amount: remittanceAmount, currencyCode };
			});
		}

		default: {
			return [];
		}
	}
};
